import type { ReactElement } from "react";
import { Flex, Text, AgGrid } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { noRowsOverlayContainer } from "./styles_vanilla.css";

export type NoRowsOverlayProps = {
  api: {
    getFilterModel: () => AgGrid.FilterModel | null;
  };
};

export const NoRowsOverlay = ({ api }: NoRowsOverlayProps): ReactElement => {
  const filterModel = api.getFilterModel();
  const hasFiltersApplied = filterModel && Object.keys(filterModel).length > 0;

  const message = hasFiltersApplied
    ? "No entities match the selected filters"
    : "Perfect, you have no unassigned entities!";

  const iconType = hasFiltersApplied ? "search" : "thumbs-up";

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      className={noRowsOverlayContainer}
    >
      <Icon
        type={iconType}
        size="large"
        color={Colors.Neutral800}
        variant="solid"
        data-testid="no-rows-overlay-icon"
      />
      <Text variant="regular-md" align="center">
        {message}
      </Text>
    </Flex>
  );
};
